(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ZzDev = Lfl.ZzDev || {};

    (function (ZzDev, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.ZzDev, 'VarPrinter')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Dumps variables into strings.
         *
         * @memberOf Lfl.ZzDev
         */
        Lfl.ZzDev.VarPrinter = ZzDev.VarPrinter || {};

        (function (VarPrinter, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            var spacing = 4;

            /**
             * @memberOf Lfl.ZzDev.VarPrinter
             * @param {*} variable
             * @param {string} maxDepth How deep objects should be printed.
             * @returns {string|*}
             */
            VarPrinter.print = function(variable, maxDepth) {
                switch (typeof variable) {
                    case "object":
                        // Note: We do not use the prune method, as it does not accept spacing parameter.
                        return JSON.stringify(Lfl.ZzDev.ObjectSimplifier.simplify(variable, maxDepth), null, spacing);
                    // Note: We could add numbers, etc.
                    default:
                        return variable;
                }
            };

            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
        }(ZzDev.VarPrinter, jQuery));
    }(Lfl.ZzDev, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
